export const CHECKOUT_FIELDS_VALUES = {
  address: '',
  country: '',
  city: '',
  state: '',
};

export const STRIPE_VALIDATION_ERRORS = {
  cardCvc: 'Please enter a real CVV.',
  postalCode: 'Please enter a real postal code.',
  cardExpiry: 'Please enter a real expiry date.',
  cardNumber: 'Please enter a real card number.',
};

export const STRIPE_REQUIRED_ERRORS = {
  cardCvc: 'Please enter your CVV.',
  postalCode: 'Please enter your postal code.',
  cardExpiry: 'Please enter your expiry date.',
  cardNumber: 'Please enter your card number.',
};
